var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMigraSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 194,
    height: 207,
    viewBox: "0 0 194 207",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M144.172 60.8135L150.393 20.5703L182.597 46.0105L144.172 60.8135Z",
    fill: "#C4DFE9",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M152.541 25.9316L149.371 46.4356",
    stroke: "white",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M162.789 57.268L163.384 53.4121L166.471 55.8495L162.789 57.268Z",
    fill: "#C4DFE9",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M107.278 152.718L108.343 157.487L111.625 169.34L116.741 165.556L119.817 151.174L113.161 145.519L110.385 145.188L108.552 146.053L84.8164 161.179",
    fill: "#EDD6BF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M107.278 152.718L108.343 157.487L111.625 169.34L116.741 165.556L119.817 151.174L113.161 145.519L110.385 145.188L108.552 146.053L84.8164 161.179",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M110.69 165.97L115.448 164.051C115.448 164.051 114.755 151.967 114.336 149.875C113.853 147.462 111.604 145.764 109.123 145.998C109.103 146 109.084 146.001 109.064 146.003L108.551 146.054L110.601 144.587C110.934 144.348 111.405 144.083 111.93 143.817C113.902 142.816 116.306 143.212 117.822 144.809L117.958 144.952C118.647 145.678 119.136 146.563 119.403 147.522C119.977 149.587 121.542 165.566 121.542 165.566C121.819 168.695 120.311 172.965 118.886 176.062C118.49 176.924 117.642 177.513 116.683 177.549C116.67 177.549 116.657 177.55 116.645 177.55C115.136 177.595 113.77 176.673 113.265 175.269L108.957 159.709",
    fill: "#B4FF00"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M110.69 165.97L115.448 164.051C115.448 164.051 114.755 151.967 114.336 149.875C113.853 147.462 111.604 145.764 109.123 145.998C109.103 146 109.084 146.001 109.064 146.003L108.551 146.054L110.601 144.587C110.934 144.348 111.405 144.083 111.93 143.817C113.902 142.816 116.306 143.212 117.822 144.809L117.958 144.952C118.647 145.678 119.136 146.563 119.403 147.522C119.977 149.587 121.542 165.566 121.542 165.566C121.819 168.695 120.311 172.965 118.886 176.062C118.49 176.924 117.642 177.513 116.683 177.549C116.67 177.549 116.657 177.55 116.645 177.55C115.136 177.595 113.77 176.673 113.265 175.269L108.957 159.709",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M108.554 146.055L98.0898 151.185C102.002 152.074 104.951 154.426 105.722 157.632C106.209 159.656 105.579 161.785 104.208 163.365L110.731 155.848",
    fill: "#EDD6BF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M108.554 146.055L98.0898 151.185C102.002 152.074 104.951 154.426 105.722 157.632C106.209 159.656 105.579 161.785 104.208 163.365L110.731 155.848",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6367 147.089L60.4776 178.494C60.4502 185.136 65.9173 190.525 72.6477 190.491C77.3061 190.468 81.7419 188.521 84.8792 185.122L109.79 162.552L108.239 154.867C107.683 152.112 106.011 149.7 103.61 148.191L85.9557 155.931L81.8593 166.065L100.241 126.266L88.1324 108.559",
    fill: "#C4DFE9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6367 147.089L60.4776 178.494C60.4502 185.136 65.9173 190.525 72.6477 190.491C77.3061 190.468 81.7419 188.521 84.8792 185.122L109.79 162.552L108.239 154.867C107.683 152.112 106.011 149.7 103.61 148.191L85.9557 155.931L81.8593 166.065L100.241 126.266L88.1324 108.559",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M121.43 152.449L122.495 157.218L125.777 169.07L130.893 165.287L133.97 150.904L127.314 145.249L124.537 144.918L122.704 145.784L98.9688 160.91",
    fill: "#EDD6BF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M121.43 152.449L122.495 157.218L125.777 169.07L130.893 165.287L133.97 150.904L127.314 145.249L124.537 144.918L122.704 145.784L98.9688 160.91",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M124.843 165.699L130.892 165.286C130.892 165.286 128.907 151.695 128.489 149.603C128.005 147.19 125.757 145.492 123.276 145.726C123.256 145.728 123.236 145.73 123.216 145.732L122.703 145.783L124.753 144.315C125.087 144.077 125.558 143.811 126.082 143.545C128.054 142.544 130.458 142.94 131.974 144.538L132.11 144.681C132.799 145.407 133.289 146.291 133.555 147.25C134.13 149.316 135.695 165.294 135.695 165.294C135.971 168.423 134.463 172.694 133.039 175.791C132.642 176.652 131.794 177.241 130.835 177.277C130.823 177.278 130.81 177.278 130.797 177.279C129.288 177.323 127.922 176.401 127.417 174.997L123.11 159.438",
    fill: "#B4FF00"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M124.843 165.699L130.892 165.286C130.892 165.286 128.907 151.695 128.489 149.603C128.005 147.19 125.757 145.492 123.276 145.726C123.256 145.728 123.236 145.73 123.216 145.732L122.703 145.783L124.753 144.315C125.087 144.077 125.558 143.811 126.082 143.545C128.054 142.544 130.458 142.94 131.974 144.538L132.11 144.681C132.799 145.407 133.289 146.291 133.555 147.25C134.13 149.316 135.695 165.294 135.695 165.294C135.971 168.423 134.463 172.694 133.039 175.791C132.642 176.652 131.794 177.241 130.835 177.277C130.823 177.278 130.81 177.278 130.797 177.279C129.288 177.323 127.922 176.401 127.417 174.997L123.11 159.438",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5138 133.663L75.7852 178.835C75.537 185.322 80.4708 190.868 87.0204 191.465C90.8016 191.809 94.5276 190.384 97.085 187.614L123.927 156.678L120.47 146.881L104.345 154.791L98.2216 170.952L108.058 144.993C110.848 137.629 111.126 129.568 108.856 122.031C108.029 119.285 107.168 116.553 106.419 114.44L101.102 110.775L62.4282 114.029L61.7598 119.321C61.0522 124.924 59.7054 130.387 59.6822 136.033L59.6367 147.09",
    fill: "#C4DFE9"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5138 133.663L75.7852 178.835C75.537 185.322 80.4708 190.868 87.0204 191.465C90.8016 191.809 94.5276 190.384 97.085 187.614L123.927 156.678L120.47 146.881L104.345 154.791L98.2216 170.952L108.058 144.993C110.848 137.629 111.126 129.568 108.856 122.031C108.029 119.285 107.168 116.553 106.419 114.44L101.102 110.775L62.4282 114.029L61.7598 119.321C61.0522 124.924 59.7054 130.387 59.6822 136.033L59.6367 147.09",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M122.706 145.783L112.242 150.913C116.155 151.802 119.104 154.154 119.874 157.36C120.361 159.384 119.731 161.514 118.361 163.094L124.884 155.576",
    fill: "#EDD6BF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M122.706 145.783L112.242 150.913C116.155 151.802 119.104 154.154 119.874 157.36C120.361 159.384 119.731 161.514 118.361 163.094L124.884 155.576",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7044 23.8426L50.4156 18.5736L44.437 14.1889C44.0817 13.9283 43.9814 13.4459 44.2039 13.0682C44.4471 12.6558 44.9842 12.5183 45.3999 12.7617L50.5162 15.7603L44.7116 9.00409C44.4038 8.64574 44.4287 8.11344 44.769 7.78463C45.1281 7.43745 45.7047 7.44439 46.055 7.80026L52.2203 14.0584L47.439 5.05064C47.1974 4.59526 47.3676 4.03294 47.8225 3.78304C48.2799 3.53165 48.857 3.68824 49.12 4.13493L54.2962 12.9277L51.6329 4.13865C51.5039 3.71281 51.7139 3.25843 52.124 3.07528C52.5865 2.86881 53.1301 3.0805 53.3255 3.54282L58.1438 14.952L59.2603 9.96943C59.5078 8.86536 60.5662 8.12882 61.7033 8.26953L61.2288 10.5958L61.4513 20.2383L68.097 31.1859L59.4213 33.6129L55.7051 23.8426H55.7044Z",
    fill: "#EDD6BF",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1444 14.9512L57.4486 15.3448C55.889 16.2272 54.7703 17.7087 54.3594 19.4357",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1668 67.1552L65.0922 23.917L64.5842 20.6328L62.1106 22.1545C59.6998 23.6375 57.3046 27.1976 56.8555 29.9659L58.2388 30.5029L76.2838 78.3899",
    fill: "#B4FF00"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1668 67.1552L65.0922 23.917L64.5842 20.6328L62.1106 22.1545C59.6998 23.6375 57.3046 27.1976 56.8555 29.9659L58.2388 30.5029L76.2838 78.3899",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9848 68.0117L73.2245 80.7074C71.9028 81.966 71.2668 83.7702 71.512 85.5663L72.6426 93.8507L68.729 100.047C63.8152 107.827 59.8959 117.047 56.4966 125.579L56.1662 126.409L53.1602 127.922C70.2129 142.617 95.1981 137.912 108.949 128.655C112.026 126.583 116.021 123.356 118.116 120.315L103.426 107.977L115.682 77.4324L111.474 72.2394L101.518 72.3009L95.0988 73.5306L89.9853 68.0117",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9848 68.0117L73.2245 80.7074C71.9028 81.966 71.2668 83.7702 71.512 85.5663L72.6426 93.8507L68.729 100.047C63.8152 107.827 59.8959 117.047 56.4966 125.579L56.1662 126.409L53.1602 127.922C70.2129 142.617 95.1981 137.912 108.949 128.655C112.026 126.583 116.021 123.356 118.116 120.315L103.426 107.977L115.682 77.4324L111.474 72.2394L101.518 72.3009L95.0988 73.5306L89.9853 68.0117",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2737 71.5813C94.4941 74.7828 104.554 76.643 115.118 76.8411L110.742 72.2791C110.569 72.2677 110.394 72.258 110.221 72.2456L101.521 72.3L95.1009 73.5296L90.6362 68.7108C90.2602 68.5996 89.885 68.487 89.5116 68.3711L85.2734 71.5813H85.2737Z",
    fill: "#002340"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M112.426 85.5525L114.168 81.2121C102.409 80.8871 91.2501 78.5938 81.1144 74.7324L77.0195 77.8342C87.8179 82.2842 99.7818 85.0082 112.426 85.5527V85.5525Z",
    fill: "#002340"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M110.688 89.8777C97.191 89.1069 84.4505 85.9595 73.0195 80.9258C71.9581 82.049 71.4028 83.5404 71.475 85.0691C82.906 90.067 95.5668 93.2539 108.957 94.1914L110.688 89.8777Z",
    fill: "#002340"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6453 93.8492L72 94.8711C82.4277 98.9672 93.694 101.696 105.508 102.794L107.232 98.496C94.7945 97.4773 82.9736 94.5889 72.1411 90.1543L72.6453 93.8494V93.8492Z",
    fill: "#002340"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M103.826 111.545C105.244 111.687 106.67 111.804 108.102 111.901L103.429 107.976L103.791 107.075C91.7367 105.832 80.2368 102.958 69.5868 98.6934L68.7326 100.046C68.2191 100.859 67.7189 101.691 67.2266 102.533C78.601 107.163 90.9115 110.261 103.826 111.545Z",
    fill: "#002340"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M98.192 119.836C104.512 120.681 110.977 121.114 117.526 121.109C117.735 120.843 117.935 120.578 118.117 120.314L113.708 116.611C109.455 116.501 105.246 116.202 101.1 115.718C88.4 114.245 76.2849 111.072 65.0505 106.451C64.3592 107.762 63.6896 109.095 63.0391 110.441C74.0308 114.99 85.834 118.195 98.192 119.837V119.836Z",
    fill: "#002340"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M113.139 125.5C107.031 125.326 101.003 124.784 95.1022 123.894C83.1969 122.107 71.8048 118.917 61.1501 114.494C60.5388 115.854 59.9453 117.217 59.3672 118.579C69.5982 122.828 80.4788 125.981 91.8329 127.884C96.9155 128.74 102.093 129.343 107.337 129.685C107.89 129.348 108.429 129.004 108.95 128.653C110.254 127.776 111.721 126.69 113.139 125.5Z",
    fill: "#002340"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3844 131.802C77.6692 129.815 67.3796 126.741 57.654 122.707C57.2622 123.67 56.8765 124.629 56.498 125.579L56.1676 126.408L55.5859 126.701C64.8499 130.567 74.6142 133.575 84.7583 135.641C86.2158 135.94 87.6823 136.216 89.1551 136.475C92.8348 135.808 96.3777 134.777 99.6573 133.482C95.8559 133.056 92.0945 132.494 88.3844 131.802Z",
    fill: "#002340"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M171.465 80.034L178.789 81.6952L185.715 84.4006C186.127 84.5614 186.595 84.3914 186.803 84.0058C187.03 83.5846 186.866 83.0615 186.437 82.8412L181.159 80.1288L190.036 81.4391C190.507 81.5085 190.952 81.2073 191.056 80.7487C191.166 80.2645 190.856 79.7846 190.365 79.6781L181.727 77.8028L192.005 77.0687C192.524 77.0315 192.919 76.5927 192.895 76.0793C192.87 75.5631 192.431 75.1616 191.908 75.1762L181.608 75.4658L190.581 73.0703C191.016 72.9542 191.297 72.5388 191.238 72.098C191.172 71.6015 190.704 71.2568 190.203 71.3364L177.838 73.3046L181.541 69.7435C182.362 68.9543 182.439 67.6783 181.719 66.7988L179.965 68.4223L171.542 73.315L158.621 73.3222L160.169 82.4791L171.465 80.034Z",
    fill: "#EDD6BF",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M177.838 73.3047L177.865 74.0956C177.926 75.8687 177.24 77.5874 175.969 78.8419",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M106.086 72.269L164.43 71.9539L167.091 69.7227L167.859 72.851C168.526 75.5658 168.265 78.4219 167.118 80.9757L108.938 93.9679",
    fill: "#B4FF00"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M106.086 72.269L164.43 71.9539L167.091 69.7227L167.859 72.851C168.526 75.5658 168.265 78.4219 167.118 80.9757L108.938 93.9679",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M99.75 37.7342L122.997 21.3457L116.221 48.7362L99.75 37.7342Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M121.867 25.9183L122.998 21.3457L116.387 26.0069L121.867 25.9183Z",
    fill: "#B4FF00"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M119.406 35.8738L120.633 30.9121L109.167 31.098L101.992 36.1557L119.406 35.8738Z",
    fill: "#B4FF00"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M116.944 45.8287L118.172 40.8672L104.77 41.0841L111.993 45.9091L116.944 45.8287Z",
    fill: "#B4FF00"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M99.75 37.7342L122.997 21.3457L116.221 48.7362L99.75 37.7342Z",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M90.465 66.7024L89.1229 70.3564L89.9849 68.0097C84.1178 72.0488 84.3622 76.6683 88.0029 79.4348C93.3621 83.5074 104.863 82.0194 103.217 72.4823C103.208 72.4335 103.221 72.3836 103.223 72.3342L101.518 72.299L101.517 73.373L101.517 74.7232L101.522 64.9718L112.211 62.3001L107.656 45.6607L98.9808 40.0527L95.5305 43.8168L91.0682 49.7727C90.942 49.9414 90.8193 50.1124 90.7003 50.2856C89.055 52.6834 88.2317 55.5389 88.1774 58.4342L88.0776 63.7459C87.9818 64.9941 88.7601 66.1463 89.9646 66.5392L91.0426 66.8908",
    fill: "#EDD6BF"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M90.465 66.7024L89.1229 70.3564L89.9849 68.0097C84.1178 72.0488 84.3622 76.6683 88.0029 79.4348C93.3621 83.5074 104.863 82.0194 103.217 72.4823C103.208 72.4335 103.221 72.3836 103.223 72.3342L101.518 72.299L101.517 73.373L101.517 74.7232L101.522 64.9718L112.211 62.3001L107.656 45.6607L98.9808 40.0527L95.5305 43.8168L91.0682 49.7727C90.942 49.9414 90.8193 50.1124 90.7003 50.2856C89.055 52.6834 88.2317 55.5389 88.1774 58.4342L88.0776 63.7459C87.9818 64.9941 88.7601 66.1463 89.9646 66.5392L91.0426 66.8908",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M116.521 47.6797L118.401 39.9209C118.401 39.9209 121.977 31.3453 133.699 39.4899C142.918 45.8966 147.848 45.205 147.848 45.205L147.817 45.4294C147.063 50.8579 144.206 55.6724 140.204 59.4705C138.959 60.6528 141.998 61.0511 141.998 61.0511C135.074 68.1271 124.956 70.8889 115.551 67.6305C115.381 67.5717 115.214 67.5104 115.049 67.4476C110.892 65.8609 106.261 65.9746 102.272 67.9353L101.539 68.2954L101.523 63.7699L104.326 62.3656L105.598 61.0731C107.388 62.3584 103.66 61.029 103.66 61.029C103.66 61.029 107.479 57.2177 105.689 55.9325C103.712 53.2496 102.601 50.0402 102.502 46.724L102.374 42.4261C100.177 42.2718 98.1742 42.7668 96.4132 43.892C95.6729 44.365 95.0204 44.9598 94.4267 45.6033L93.1746 46.9602C92.5004 45.0117 91.0487 37.7046 96.1082 36.1975C96.7776 35.9983 98.0404 36.1107 99.5583 36.3918C106.385 37.656 112.377 41.6551 116.278 47.3268L116.521 47.6797H116.521Z",
    fill: "#968879",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9193 48.5879L91.0688 53.6615C91.0688 53.6615 90.9139 54.7889 92.143 55.6749",
    fill: "#EDD6BF"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9193 48.5879L91.0688 53.6615C91.0688 53.6615 90.9139 54.7889 92.143 55.6749",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M104.412 55.9219L106.855 52.7227C109.385 54.1871 109.877 57.9956 107.955 61.2296C106.033 64.4634 102.424 65.8977 99.8945 64.4333",
    fill: "#EDD6BF"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M104.412 55.9219L106.855 52.7227C109.385 54.1871 109.877 57.9956 107.955 61.2296C106.033 64.4634 102.424 65.8977 99.8945 64.4333",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M102.514 48.7719C102.438 48.7719 102.363 48.7436 102.304 48.6867C101.798 48.1929 101.178 47.8224 100.514 47.6157C100.356 47.5668 100.269 47.401 100.319 47.2457C100.368 47.0901 100.536 47.0037 100.694 47.0529C101.448 47.2876 102.151 47.7075 102.725 48.2671C102.842 48.3818 102.843 48.5681 102.727 48.6843C102.669 48.7426 102.592 48.7719 102.514 48.7719Z",
    fill: "#002340"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2132 45.8812C97.135 45.8812 97.0568 45.8511 96.998 45.7911C96.5192 45.301 95.8045 45.0933 95.1326 45.2474C94.9724 45.2856 94.8112 45.1861 94.7735 45.0272C94.736 44.8687 94.8359 44.7098 94.9966 44.6729C95.8724 44.4714 96.8041 44.7428 97.428 45.3814C97.5424 45.4985 97.5391 45.6854 97.4202 45.7983C97.3621 45.8534 97.2874 45.8809 97.2127 45.8809L97.2132 45.8812Z",
    fill: "#002340"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7878 50.5211C92.6684 50.5211 92.5487 50.4712 92.4614 50.3849C92.3787 50.3032 92.3281 50.1853 92.3281 50.0675C92.3281 49.9449 92.3787 49.8315 92.4614 49.7453C92.5718 49.6409 92.7282 49.591 92.8798 49.6228C92.9075 49.6272 92.9352 49.6362 92.9626 49.6453C92.99 49.659 93.0176 49.6726 93.0453 49.686C93.0684 49.7042 93.0913 49.7223 93.1142 49.7451C93.2015 49.8312 93.2475 49.9446 93.2475 50.0672C93.2475 50.1851 93.2015 50.3032 93.1142 50.3846C93.0911 50.4074 93.0682 50.4256 93.0453 50.4437C93.0176 50.4571 92.99 50.4754 92.9626 50.4844C92.9349 50.4978 92.9073 50.5025 92.8798 50.5117C92.8477 50.5161 92.8202 50.5208 92.7878 50.5208V50.5211Z",
    fill: "#002340"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4675 53.5465C98.348 53.5465 98.2283 53.4966 98.1411 53.415C98.0996 53.3696 98.0674 53.3242 98.0445 53.2651C98.0216 53.2105 98.0078 53.1517 98.0078 53.0926C98.0078 52.9745 98.0583 52.8566 98.1411 52.7705C98.3111 52.6025 98.6239 52.6025 98.7939 52.7705C98.8766 52.8566 98.9272 52.9745 98.9272 53.0926C98.9272 53.1515 98.9133 53.2105 98.8904 53.2651C98.8673 53.3239 98.8351 53.3696 98.7939 53.415C98.7066 53.4966 98.5869 53.5465 98.4675 53.5465Z",
    fill: "#002340"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M91.043 66.8919C93.4339 67.6972 96.3886 66.8542 97.8783 64.8406L104.411 55.9227L113.399 43.8867",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M116.521 47.6797C117.23 48.7555 117.459 49.7255 117.201 50.5633C116.875 51.6222 115.889 52.0523 115.848 52.0699",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6758 56.7559C90.6135 57.8234 91.5067 59.2608 95.7423 58.3689C93.7306 60.9436 92.29 61.4888 91.1376 61.0833C90.0138 60.6877 90.186 59.6725 90.4925 57.6485",
    fill: "#EDD6BF"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6758 56.7559C90.6135 57.8234 91.5067 59.2608 95.7423 58.3689C93.7306 60.9436 92.29 61.4888 91.1376 61.0833C90.0138 60.6877 90.186 59.6725 90.4925 57.6485",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M104.989 23.9102L100.891 33.3417",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6992 33.832L88.2561 37.8766",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7617 23.498L93.6209 33.0269",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0646 153.751C90.1777 154.088 89.2908 154.426 88.4039 154.764C85.5347 150.973 85.1683 146.446 87.3918 142.254C88.3217 142.448 89.2516 142.643 90.1817 142.838C88.2419 146.494 88.5616 150.444 91.0646 153.751V153.751Z",
    fill: "white",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4382 42.9861C45.7116 43.3829 38.1523 51.4861 38.5544 61.0849C38.9565 70.684 47.1675 78.1439 56.8942 77.7471C65.0313 77.4151 71.6478 71.6885 73.3588 64.206L79.9853 59.3949L72.979 55.14C70.6482 47.8222 63.5753 42.654 55.4379 42.9858L55.4382 42.9861Z",
    fill: "white",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7504 56.4456C47.0398 53.7469 49.4908 51.7909 52.2255 52.0765C54.2357 52.2865 55.8353 53.6511 56.4287 55.4304C57.3865 53.8131 59.2403 52.8091 61.2503 53.019C63.9847 53.3047 65.967 55.7237 65.6776 58.4222C65.5594 59.5251 65.0761 60.4998 64.3642 61.2523L64.3677 61.2542L54.7349 71.2271L47.4399 59.5022L47.4444 59.501C46.9013 58.6148 46.6314 57.5554 46.7504 56.4459V56.4456Z",
    fill: "#B4FF00",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M29.74 85.9599C29.3319 85.1127 28.9238 84.2655 28.5156 83.418C32.1292 80.3086 36.6764 79.6065 41.0798 81.4782C40.9533 82.408 40.827 83.3379 40.7006 84.2677C36.8592 82.6349 32.8926 83.2473 29.7403 85.9599H29.74Z",
    fill: "#B4FF00",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5556 175.247L20.7539 184.609L23.375 186.464L30.1766 177.101L27.5556 175.247Z",
    fill: "#B4FF00",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M170.34 137.207C170.711 138.071 171.082 138.934 171.453 139.798C167.708 142.752 163.135 143.261 158.816 141.205C158.983 140.281 159.15 139.358 159.317 138.434C163.084 140.228 167.073 139.784 170.34 137.207H170.34Z",
    fill: "#002340",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2042 157.394L32.1016 148.109L29.4992 146.227L22.6018 155.512L25.2042 157.394Z",
    fill: "#002340",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1198 87.7188C44.8652 88.3009 45.6105 88.8834 46.3558 89.4658C44.5048 93.8305 40.7391 96.4419 35.9508 96.6811C35.6482 95.7917 35.3455 94.9025 35.043 94.0131C39.22 93.8044 42.5052 91.5263 44.1198 87.7188Z",
    fill: "white",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3838 69.6966L24.1992 62.1562L22.0858 59.7499L13.2703 67.2903L15.3838 69.6966Z",
    fill: "#002340",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6159 133.061C44.5662 133.037 45.5164 133.014 46.467 132.99C47.8767 137.512 46.678 141.898 43.1549 145.107C42.3455 144.615 41.536 144.123 40.7266 143.631C43.8 140.831 44.8455 137.006 43.6159 133.061V133.061Z",
    fill: "white",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M45.047 168.281L52.5012 177.107L50.0401 179.153L42.5859 170.328L45.047 168.281Z",
    fill: "white",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1406 96.5656C88.0414 96.2656 88.9421 95.9658 89.8429 95.666C92.5448 99.5745 92.7143 104.113 90.3108 108.207C89.3902 107.974 88.4694 107.74 87.5488 107.506C89.6455 103.935 89.4978 99.9753 87.1406 96.5656Z",
    fill: "#B4FF00",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M135.225 132.193L126.363 124.705L124.265 127.124L133.126 134.612L135.225 132.193Z",
    fill: "#B4FF00",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M144.688 156.674C145.332 155.984 145.977 155.295 146.622 154.605C150.892 156.756 153.246 160.659 153.127 165.389C152.206 165.619 151.284 165.85 150.363 166.081C150.467 161.954 148.413 158.55 144.688 156.674Z",
    fill: "#C4DFE9",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2246 204.082C77.7164 204.874 77.2082 205.667 76.7 206.46C72.1068 205.104 69.0781 201.684 68.332 197.01C69.1963 196.62 70.0603 196.228 70.9249 195.838C71.5759 199.915 74.2178 202.899 78.2249 204.082L78.2246 204.082Z",
    fill: "#002340",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1433 111.264L56.6641 103.357L54.4479 105.672L62.9271 113.579L65.1433 111.264Z",
    fill: "#C4DFE9",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8041 1.52768L98.2969 12.1523L101.275 10.926L96.782 0.301311L93.8041 1.52768Z",
    fill: "#002340",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M102.297 39.7812L102.504 46.7263L102.297 39.7812Z",
    fill: "#968879"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M102.297 39.7812L102.504 46.7263",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M37.332 43.243C36.6445 42.595 35.957 41.9471 35.2695 41.2994C37.5216 37.1223 41.5159 34.8661 46.3063 35.0648C46.5241 35.9781 46.7423 36.8911 46.9601 37.8043C42.7813 37.6308 39.2967 39.5992 37.332 43.243Z",
    fill: "#B4FF00",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M130.113 7.76758L140.462 13.1137L138.959 15.934L128.609 10.5879L130.113 7.76758Z",
    fill: "#B4FF00",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3164 26.9319C73.2561 27.0733 74.1958 27.215 75.1355 27.3567C75.7179 32.0532 73.757 36.1622 69.7175 38.7106C69.0084 38.0857 68.299 37.4613 67.5898 36.8365C71.1139 34.6135 72.8246 31.0288 72.3164 26.9316V26.9319Z",
    fill: "#C4DFE9",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M151.471 76.7973L154.559 65.6953L151.447 64.8524L148.359 75.9544L151.471 76.7973Z",
    fill: "white",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M128.229 47.6133C129.149 47.8485 130.069 48.084 130.99 48.3195C131.084 53.05 128.709 56.9404 124.427 59.0691C123.786 58.3762 123.145 57.6836 122.504 56.9908C126.239 55.1338 128.311 51.7399 128.229 47.6133Z",
    fill: "white",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M126.18 104.123C125.513 103.455 124.846 102.786 124.18 102.117C126.562 98.0113 130.625 95.8783 135.407 96.2238C135.596 97.1432 135.785 98.0627 135.974 98.9821C131.803 98.6808 128.258 100.542 126.18 104.123H126.18Z",
    fill: "#C4DFE9",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0799 37.5491L18.9414 31.8535L17.3452 34.6207L27.4837 40.3163L29.0799 37.5491Z",
    fill: "white",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M32.204 120.951C38.1326 115.1 38.1326 105.614 32.204 99.7638C26.2754 93.9131 16.6633 93.913 10.7347 99.7638C4.80608 105.614 4.80609 115.1 10.7347 120.951C16.6633 126.802 26.2754 126.802 32.204 120.951Z",
    fill: "#B4FF00",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2193 104.154C6.75307 110.07 8.81005 117.666 14.8044 121.086",
    stroke: "white",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1302 121.465L34.6094 117.856L38.5383 117.355L36.1302 121.465Z",
    fill: "#B4FF00",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M145.965 119.917L149.727 118.49L149.291 122.445L145.965 119.917Z",
    fill: "#002340",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M179.552 104.445L156.234 86.5332L138.084 109.544L161.402 127.456L179.552 104.445Z",
    fill: "#002340",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M156.511 90.6973L147.953 101.548",
    stroke: "white",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M115.032 198.774L124.371 191.902L122.441 189.348L113.102 196.219L115.032 198.774Z",
    fill: "white",
    stroke: "#002340",
    strokeWidth: 0.602804,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMigraSuccess);
export default __webpack_public_path__ + "static/media/migra-success.cbb55e4f144afaf234c30d92f1fcf84f.svg";
export { ForwardRef as ReactComponent };